<template>
	<div class="cbs-attachment-control">
		<legend class="flex justify-between items-center">
			<div>
				{{ value.title }}<span class="text-danger" v-if="!value.is_optional">&nbsp;*</span>:
			</div>
			<cbs-hint
				v-if="
					value.description &&
					value.description.enable &&
					value.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON
				"
				:data="value.description && value.description.value"
			/>
		</legend>

		<div
			class="my-1"
			v-if="
				value.description &&
				value.description.enable &&
				value.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP
			"
		>{{ value.description && value.description.value }}</div>
		<cbs-upload-ref
			v-validate="!value.is_optional ? 'required' : ''"
			:data-vv-as="value.title"
			:name="`${value.title}-${value.id}`"
			:value="localAttachFiles"
			@input="handleSetNewFiles"
		/>
		<span
			class="text-danger text-sm"
			v-if="!value.is_optional"
		>{{ errors.first(`${value.title}-${value.id}`) }}</span>
		<div
			class="my-1"
			v-if="
				value.description &&
				value.description.enable &&
				value.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM
			"
		>{{ value.description && value.description.value }}</div>
	</div>
</template>

<script>
import CbsHint from "@/components/cbs-hint/CbsHint.vue";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

export default {
	name: "AttachmentControl",
	inject: ["parentValidator"],
	components: {
		CbsHint,
		CbsUploadRef
	},
    props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		},
		mappedAttachObj: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			localMappedAttachObj: { ...this.mappedAttachObj }
		}
	},
    computed: {
		localAttachFiles() {
			return this.value.value.map(fileId => this.localMappedAttachObj[fileId]);
		}
	},
	methods: {
		handleSetNewFiles(files) {
			const newLocalMappedAttachObj = {};
			files.forEach(file => newLocalMappedAttachObj[file.id] = file);
			this.localMappedAttachObj = newLocalMappedAttachObj;
			this.$emit("input", {
				...this.value,
				value: files.map(file => file.id)
			});
			this.$emit("onChange", files);
		}
	},
	created() {
        if (this.parentValidator) {
            this.$validator = this.parentValidator;
		}
	}
}
</script>

<style>

</style>